<template>
  <div class="main">
    <div class="back">
      <div v-if="windowSize > 600" class="title">
        <h2 class="header">
          One cart for all<br /> your favorite websites
        </h2>
        <span class="description font">
          Shop, Save and Share with Shopdrop.
        </span>
        <div class="my-2 add-button">
          <v-btn @click="openChromeStore" large color="rgb(20, 200, 200)">Add to Chrome</v-btn>
        </div>
      </div>
    </div>

    <div class="row odd">
      <div class="col">
        <h2 class="header-font">Save content from everywhere.</h2>
        <p class="font">Save items from all your favorite online stores. Build your own wishlist with everything you wish to buy.</p>
      </div>
      <div class="col">
        <v-icon :size="windowSize > 500 ? 300 : 100">mdi-store</v-icon>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <v-icon :size="windowSize > 500 ? 300 : 100">mdi-tag-outline</v-icon>
      </div>
      <div class="col">
        <h2 class="header-font">Create categories for better organization.</h2>
        <p class="font">If you want to organize your saved items, just divide them into categories.</p>
      </div>
    </div>

    <div class="row odd">
      <div class="col">
        <h2 class="header-font">Get discount notifications.</h2>
        <p class="font">Keep up to date with all your favorite products and get exclusive deals.</p>
      </div>
      <div class="col">
        <v-icon :size="windowSize > 500 ? 300 : 100">mdi-currency-usd-off</v-icon>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <v-icon :size="windowSize > 500 ? 300 : 100">mdi-account-star</v-icon>
      </div>
      <div class="col">
        <h2 class="header-font">Share what you liked.</h2>
        <p class="font">Share with friends and family. Hear their thoughts and share your own!</p>
      </div>
    </div>

    <div class="row bottom-row">
      <div class="row">
        <div class="col" @click="openUrl(`https://www.consoleskinsworld.com/`)">
          <v-img :size="windowSize > 500 ? 300 : 100" contain src="../../images/consoleSkinsWorld.png" class="partner-logo" />
        </div>
        <div class="col" @click="openUrl(`https://rayoswim.com/`)">
          <v-img :size="windowSize > 500 ? 300 : 100" contain src="../../images/Rayo.png" class="partner-logo" />
        </div>
        <div class="col" @click="openUrl(`https://theplug.co.il/`)">
          <v-img :size="windowSize > 500 ? 300 : 100" contain src="../../images/ThePlugLogo.png" class="partner-logo" />
        </div>
        <div class="col" @click="openUrl(`https://mesh.shoes/`)">
          <v-img :size="windowSize > 500 ? 300 : 100" contain src="../../images/Mesh.png" class="partner-logo" />
        </div>
      </div>

      <h3 class="header-font">Try Shopdrop now!</h3>
      <div class="my-2">
        <v-btn @click="openChromeStore" large color="rgb(20, 200, 200)">Add to Chrome</v-btn>
      </div>
    </div>
    <div class="footer row odd">
      <a @click="() => this.$router.push({name: 'privacyAndTerms'})" class="privacy-policy">Privacy Policy</a>
      <p class="email"> - shopwithshopdrop@gmail.com</p>
    </div>
    <button class="container">
      <img src="" alt="Snow">
    </button>
  </div>
</template>

<script>
export default {
  name: "LandingPage",

  data: () => ({
    windowSize: window.innerWidth,
  }),
  methods: {
    openChromeStore: function () {
      window.open(
        "https://chrome.google.com/webstore/detail/dropshop/gemeodelaigfdiekcialemndbakgdicl?hl=en&authuser=2",
        "_blank"
      );
    },
    openUrl(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.main {
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
}
.back {
  display: flex;
  background: url(../../images/1.jpg) no-repeat center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  width: 100%;
  height: 650px;
  border: 2px solid #000;
  box-shadow: 0 0 8px 2px rgba(0, 0, 0, 0.8);
}
.header {
  font-size: 40px;
  font-weight: 700;
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.25;
  margin-top: 10px;
}
.title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 50px;
  max-width: 500px;
  margin-left: 10%;
}
.row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  width: 100%;
}
.odd {
  background-color: whitesmoke;
}
.bottom-row {
  background-image: url(../../images/bottom1.jpg);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}
.col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  max-width: 350px;
  margin-left: 40px;
  margin-right: 40px;
}
.header-font {
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.25;
  font-weight: 500;
  font-size: 32px;
}
.font {
  font-family: graphik lcg, proxima-nova, Helvetica Neue, Helvetica, Arial,
    sans-serif;
  line-height: 1.75;
}
.footer {
  display: flex;
  justify-content: center;
  padding: 30px;
}
.partner-logo {
  display: flex;
  max-width: 150px;
  cursor: pointer;
}
.privacy-policy {
  margin: 10px;
}
.email {
  margin: 10px;
}

.container {
  position: relative;
  width: 50%;
}

/* Make the image responsive */
.container img {
  width: 100%;
  height: auto;
}

/* Style the button and place it in the middle of the container/image */
.container .btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  background-color: #555;
  color: white;
  font-size: 16px;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.container .btn:hover {
  background-color: black;
}

@media screen and (max-height: 700px) {
  .row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .odd {
    background-color: whitesmoke;
    flex-direction: column-reverse;
  }
}
</style>
